module.exports = __webpack_public_path__ + "img/Home_images1.ba553cc4.png";